import { render, staticRenderFns } from "./ProtocolsCertificateTable.vue?vue&type=template&id=69cbf1d4&"
import script from "./ProtocolsCertificateTable.vue?vue&type=script&lang=js&"
export * from "./ProtocolsCertificateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports